import { CountryCode } from "./CountryCode";
import { LanguageCode } from "./Languages.Interface";

export enum UnitStandard {
  METRIC = "metric",
  IMPERIAL = "imperial"
}

export interface UnitsAndLocalizationInterface {
  distance?: UnitStandard;
  temperature?: UnitStandard;
  length?: UnitStandard;
  languages?: LanguageCode[];
  phoneNumberCounrtyCodes?: CountryCode[];
  countries?: CountryCode[];
  currencySymbol?: string;
  // speed: "milesPerHour" | "kilometersPerHour"
  // volume: "gallons" | "liters"
  // weight: "pounds" | "kilograms"
  // pressure: "psi" | "kPa"
  // area: "squareInches" | "squareCentimeters"
  // fuelEfficiency: "milesPerGallon" | "litersPer100Kilometers"
  // energy: "kilowattHours" | "joules"
  // power: "horsepower" | "kilowatts"
  // torque: "footPounds" | "newtonMeters"
}
